<template>
</template>

<style lang='scss' scoped>

</style>

<script lang="ts" setup>
import {ElLoading, ElMessage, ElMessageBox} from "element-plus";
import {reactive, toRaw} from "vue";
import callApi from "@/api/api";
import {loginUserStore} from "@/stores/loginUserStore";
import {useRouter} from "vue-router";
const loadingInstance = ElLoading.service({"text":"授权登录中..."})
import router from "@/router";

const params = new URLSearchParams(window.location.search);
const branchId = params.get('branchId');
const username = params.get('username');
const roleId = params.get('roleId');
const url = params.get('url');


let requestData = {"branchId":branchId,"username":username,"roleId":roleId,"url":url}
const openLogin = async () => {
  if(branchId===null || username===null || roleId===null || url===null){
    alert("授权失败")
    return;
  }
  const responseData = await callApi('/infoaccountadmin/open/thirdLogin', 'post', requestData);
  if (responseData) {
    //console.log(data.data)
    loginUserStore().setLoginUser(responseData.data);
    // 跳转 首页
    if(url == null){
      // 跳转 首页
      await router.push('/index');
    }else{
      await router.push(url);
    }
  }
}

openLogin();





</script>